import React from "react";

import FormalizerInputField from "../InputField";

type Props = {
    name: string;
};

const FormalizerEmailField = ({ name }: Props) => {
    return <FormalizerInputField name={name} type="email" />;
};

export default FormalizerEmailField;
